import React from 'react';
import T from 'prop-types';
import cx from 'classnames';
import { isUndefined } from 'lodash-es';

import {
  Menu,
  MenuItem,
  MenuButton,
  useMenuProps,
} from '../DropdownSet';

const SimpleDropdown = ({
  selected,
  options,
  size,
  caret = true,
  shape,
  variant = 'transparent',
  frameless = false,
  portal,
  position,
  disabled,
  menuAlign = 'start',
  menuDirection,
  menuGap,
  menuWidth = 240,
  menuStyle,
  className,
  unselectedStateText,
  isActiveSelectable = true,
  onChange,
  onMenuChange,
}) => {
  const menuProps = useMenuProps({
    align: menuAlign,
    direction: menuDirection,
    ...(menuGap ? { gap: menuGap } : {}),
    ...(!isUndefined(portal) ? { portal } : {}),
    ...(position ? { position } : {}),
    menuStyle: { width: menuWidth, ...(menuStyle || {}) },
    className,
  });

  const selectedOption = options.find(option => option.value === selected) || {};

  const handleChange = ({ value }) => {
    onChange(value);
  };

  return (
    <Menu
      menuButton={(
        <MenuButton
          size={size}
          disabled={disabled}
          frameless={frameless}
          caret={caret}
          shape={shape}
          variant={variant}
        >
          {selectedOption.buttonLabel || selectedOption.label || unselectedStateText}
        </MenuButton>
      )}
      {...menuProps}
      onMenuChange={onMenuChange}
    >
      {options.map(({
        label,
        value,
        disabled: optionDisabled = false,
        className: optionClassName,
        itemClass = '',
      }, index) => {
        const isActive = selectedOption.value === value;

        return (
          <MenuItem
            key={value || `menu-item-${index}`}
            value={value}
            disabled={optionDisabled}
            className={cx({ active: isActive }, optionClassName, itemClass)}
            data-testid={value}
            onClick={event => (isActiveSelectable || !isActive) && handleChange(event)}
          >
            {label}
          </MenuItem>
        );
      })}
    </Menu>
  );
};

SimpleDropdown.propTypes = {
  selected: T.oneOfType([T.string, T.number]),
  options: T.array.isRequired,
  size: T.oneOf(['sm', 'md', 'lg']),
  caret: T.bool,
  shape: T.string,
  variant: T.string,
  frameless: T.bool,
  portal: T.oneOfType([T.bool, T.object]),
  position: T.string,
  disabled: T.bool,
  menuAlign: T.oneOf(['start', 'end']),
  menuDirection: T.string,
  menuGap: T.number,
  menuWidth: T.number,
  menuStyle: T.object,
  className: T.string,
  unselectedStateText: T.node,
  isActiveSelectable: T.bool,
  onChange: T.func.isRequired,
  onMenuChange: T.func,
};

export default SimpleDropdown;
